import React, { PureComponent } from 'react';
import {
  Card, Form, Container, Grid,
} from 'tabler-react';
import { PayPalButton } from 'react-paypal-button-v2';

class Purchase extends PureComponent {
  state = { amount: 1000 };

  render() {
    return (
      <Container>
        <Grid.Row>
          <Grid.Col xs="6" className="mx-auto mt-6">
            <Card title="Pay for FtaKit Pro">
              <Card.Body>
                <p>
My goal with
                  <strong> FtaKit Pro </strong>
is to provide a tool thay everyone can use to better access and use BidFTA
                </p>
                <p>
I understand that some people may find great value in this tool, and others might not have much need for it. In light of that, I am charging
                  <strong> whatever you want to pay for Pro access </strong>
                </p>
                <p>
                  Pro Access grants you the following features:
                </p>
                <ul className="emoji-list">
                  <li>
                    <strong>Daily keyword alerts</strong>
                    {' '}
on items you are interested in
                  </li>
                  <li>
Access to the
                    <strong> Advanced Search </strong>
tool
                  </li>
                  <li>
                    <strong>Download a CSV/Excel dump </strong>
of all active items
                  </li>
                </ul>
                <p>
                  {'If you have questions or comments, please reach out! I would be happy to answer any questions or concerns. You can reach me at '}
                  <a href="mailto:support@bidft.auction">support@bidft.auction</a>
                </p>
                <Form.Group label="Amount">
                  <Form.Ratio
                    defaultValue={10}
                    max={50}
                    min={3}
                    step={1}
                    value={this.state.amount / 100}
                    onChange={({ target: { value } }) => this.setState({ amount: value * 100 })}
                    className="mb-2"
                  />
                  <Form.SelectGroup>
                    <Form.SelectGroupItem
                      label="$5"
                      name="amount"
                      value="500"
                      onClick={({ target: { value } }) => this.setState({ amount: value })}
                    />
                    <Form.SelectGroupItem
                      label="$10"
                      name="amount"
                      value="1000"
                      onClick={({ target: { value } }) => this.setState({ amount: value })}
                    />
                    <Form.SelectGroupItem
                      label="$15"
                      name="amount"
                      value="1500"
                      onClick={({ target: { value } }) => this.setState({ amount: value })}
                    />
                    <Form.SelectGroupItem
                      label="$20"
                      name="amount"
                      value="2000"
                      onClick={({ target: { value } }) => this.setState({ amount: value })}
                    />
                  </Form.SelectGroup>
                  <PayPalButton
                    amount={`${this.state.amount / 100}`}
                    options={{ clientId: process.env.REACT_APP_PAYPAL_CLIENT_ID }}
                    onSuccess={(details, data) => {
                      console.log(details, data);
                      // OPTIONAL: Call your server to save the transaction
                      // return fetch('/paypal-transaction-complete', {
                      //   method: 'post',
                      //   body: JSON.stringify({
                      //     orderID: data.orderID,
                      //   }),
                      // });
                    }}
                  />
                </Form.Group>
              </Card.Body>
              {/*              <StripeCheckout
                stripeKey={process.env.REACT_APP_STRIPE_PUBLIC_KEY}
                token={this.onToken}
                description="FtaKit Pro"
                image={require('../components/AppIconWhiteBG.png')}
                name="FtaKit - BidFTA Search Toolkit"
                panelLabel="Purchase for {{amount}}"
                amount={this.state.amount}
              /> */}
            </Card>
          </Grid.Col>
        </Grid.Row>
      </Container>
    );
  }
}

export default Purchase;



// WEBPACK FOOTER //
// ./src/purchase/index.js